
/** @format */

import React from 'react';
import {
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Button,
} from '@mui/material';
import { useStyles } from './style';
import jMoment from 'moment-jalaali';
import clsx from 'clsx';
import copy from 'copy-to-clipboard';
import createToast from 'components/Toast/Toast';
import { useNavigate } from 'react-router-dom';
import { Icons } from 'components';
import { useCurrencyUnit } from 'hooks';
  

const Constraints = ({ codes = [], totalCount = 0, user }) => {
  // --HOOKS--//
  const navigate = useNavigate();
  const classes = useStyles();
  const currencyText = useCurrencyUnit(false);

  // -- API REQUESTS --//
  const copyItem = async (v) => {
    try {
      await copy(v);
      createToast('موفق', 'کد بن کپی شد.', 'success');

    } catch (e) {
      createToast('خطا', 'خطا در کپی کردن کد بن.', 'danger');

    }
  };
  return codes?.length === 0 ? (
    <div />
  ) : (
    <Grid
      container
      direction="row"
      alignItems="center"
      item
      className={classes.root}
    >
      <Grid item xs={12}>
        <Grid container xs={12} md={9} className={classes.info}>
          <Grid item xs={12} md={6} lg={4} className={classes.detail}>
            <Typography className={classes.detailTitle}>عنوان بن شارژ</Typography>
            <Typography className={classes.detailValue}>{codes[0]?.name}</Typography>
          </Grid>
          <Grid item xs={12} md={6} lg={4} className={classes.detail}>
            <Typography className={classes.detailTitle}>تعداد بن صادر شده</Typography>
            <Typography className={classes.detailValue}>{codes?.length ?? '-'}</Typography>
          </Grid>

          <Grid item xs={12} md={6} lg={4} className={classes.detail}>
            <Typography className={classes.detailTitle}>مبلغ بن</Typography>
            <Typography className={classes.detailValue}>
              {codes[0]?.creditAmount
                ? <PriceLabel amount={codes[0].creditAmount} currency={currencyText} /> 
                : '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6} lg={4} className={classes.detail}>
            <Typography className={classes.detailTitle}>تاریخ انقضا</Typography>
            <Typography className={classes.detailValue}>
              {codes[0]?.expireDate
                ? jMoment(codes[0].expireDate)?.format('dddd, jD jMMMM jYYYY') ?? '-'
                : '-'}
            </Typography>
          </Grid>
          {codes[0]?.guild?.name ? (
            <Grid item xs={12} md={6} lg={4} className={classes.detail}>
              <Typography className={classes.detailTitle}>
                حساب تفصیلی (محل بلوکه شدن مبالغ)
              </Typography>
              <Typography className={classes.detailValue}>
                {codes[0]?.guild?.name ?? '-'}
              </Typography>
            </Grid>
          ) : null}
          {codes[0]?.limitedConsumer ? (
            <Grid item xs={12} md={6} lg={4} className={classes.detail}>
              <Typography className={classes.detailTitle}>کاربر مجاز به استفاده</Typography>
              <Typography className={classes.detailValue}>
                {codes[0]?.limitedConsumer?.id}. {codes[0]?.limitedConsumer?.name}
              </Typography>
            </Grid>
          ) : null}

        </Grid>
      </Grid>
      <Grid item xs={12} md={6} lg={4} style={{ marginTop: 20 }}>
        <List dense={false} className={classes.list}>
          <ListItem className={classes.titleBox}>
            <ListItemText primary="شماره" />
            <ListItemText primary="کد بن" />
          </ListItem>
          {codes.map((v, k) => (
            <ListItem key={k} className={clsx(k % 2 !== 0 ? 'odd' : '', classes.listItem)}>
              <ListItemText primary={v?.id} />
              <ListItemText primary={v?.hash} />
              <ListItemSecondaryAction>
                <IconButton
                  className={classes.copyIcon}
                  onClick={() => copyItem(v?.hash)}
                  size="large">
                  <Icons icon="copy" color="#d1d8dc" hover="#303d8f" size="20" />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </Grid>

      {totalCount > 10 ? (
        <Grid item xs={12} className={classes.moreContainer}>
          <Typography className={classes.more}>
            برای مشاهده همه بن‌های ایجاد شده به صفحه
            <Button
              onClick={() => navigate('/CreditVoucher')}
              className={classes.moreButton}
              color="primary"
            >
              لیست بن‌های شارژ
            </Button>
            مراجعه کنید.
          </Typography>
        </Grid>
      ) : null}
    </Grid>
  );
};


export default Constraints;
